/**
 * The one shape an `html_embed` file path may take: a path under `/embeds/` ending in `.html`,
 * built only from letters, digits, `.`, `_` and `-`, each segment opening on a letter or digit.
 * The player appends it to the public storage host, so the path is all a story carries.
 *
 * The allow-list is what keeps the frame on that host. A scheme (`https:`, `javascript:`), a
 * protocol-relative `//host`, a backslash, a query or fragment, and an encoded character all
 * need a character outside it, and `..` is refused by name.
 */
const EMBED_SRC = /^\/embeds\/[a-z0-9][\w.-]*(?:\/[a-z0-9][\w.-]*)*\.html$/i;

export const isEmbedSrc = (value: unknown): value is string =>
  typeof value === 'string' && EMBED_SRC.test(value) && !value.includes('..');
